<template>
  <div>

    <div class="sort-area">
      <div class="left">

        <label for="locations" class="select w-icon">
          <button class="button button-grey square" @click="triggerSelect('locations')">
            <img src="../assets/icon-filter.svg">
          </button>
          <select id="locations" v-model="payload.location" @change="addToPayload" open>
            <option value="" selected hidden disabled>LOCATION</option>
            <option v-for="location of $store.state.locations" :value="location" :key="location">{{ location }}</option>
          </select>
        </label>
        <label for="name" class="input w-icon">
          <button class="button button-grey square"><img src="../assets/icon-search.svg"></button>
          <input type="text" id="name" placeholder="Search by name" v-model="payload.nameSearch">
        </label>

      </div>
      <div class="right">

        <div class="size">
          <label for="">VIEW</label>
          <button
            class="button button-grey square" :class="{active: isActive === 'small'}"
            @click="toggleSize('small')"
          >
            <img src="../assets/icon-square.svg">
          </button>
          <button
            class="button button-grey square" :class="{active: isActive === 'large'}"
            @click="toggleSize('large')"
          >
            <img src="../assets/icon-square.svg">
          </button>
        </div>

        <div class="selects">
          <label for="mood" class="select w-icon">
            <button class="button button-grey square">
              <img src="../assets/icon-down.svg">
            </button>
            <select id="mood" v-model="payload.mood" @change="addToPayload">
              <option value="" selected hidden disabled>MOOD</option>
              <option value="all">all</option>
              <option value="original">original</option>
              <option value="sad">Sad</option>
              <option value="happy">Happy</option>
              <option value="angry">Angry</option>
              <option value="flirty">Flirty</option>
              <option value="love-struck">Love Struck</option>
              <option value="rainbow">Rainbow</option>
            </select>
          </label>

          <label for="sort" class="select w-icon">
            <button class="button button-grey square">
              <img src="../assets/icon-filter.svg">
            </button>
            <select id="sort"  v-model="payload.sortBy" @change="addToPayload">
              <option value="" selected hidden disabled>SORT BY</option>
              <option value="recent">Most Recent</option>
              <option value="most">Most Likes</option>
              <option value="az">A-Z</option>
              <option value="za">Z-A</option>
            </select>
          </label>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'GalleryFilter',
  data () {
    return {
      size: 'large',
      isActive: 'small',
      name: null,
      payload: {
        location: '',
        nameSearch: '',
        mood: '',
        sortBy: '',
        page: 1
      }
    }
  },
  watch: {
    'payload.nameSearch' (value) {
      this.$emit('filterPayload', this.payload)
    }
  },
  methods: {
    toggleSize (size) {
      this.isActive = size
      this.$emit('filterTileAmount', size)
    },
    addToPayload () {
      this.$emit('filterPayload', this.payload)
    },
    triggerSelect (dropdown) {
      console.log(document.getElementById(dropdown))
      // document.getElementById(dropdown).click()
      document.getElementById(dropdown).dispatchEvent(new Event('mousedown'))
    }
  }
}
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";

.sort-area {
  display: inline-block;
  width: 100%;
  padding: 36px 3% 30px;

  .select.w-icon {
    margin-bottom: 5px;
  }

  .input.w-icon {
    margin-bottom: 5px;
    input {
      border-radius: 0 5px 5px 0;
    }
  }

  .left {
    float: left;
    width: 100%;
    // margin-bottom: 15px;
    @media (min-width: $medium) {
        width: 50%;
        margin-bottom: 0;
    }

    select {
      width: 204px;
      margin-right: 16px;
    }

    input {
      width: 260px;
      padding-left: 50px;
    }
  }

  .right {
    float: left;
    width: 100%;
    @media (min-width: $medium) {
      float: right;
      width: 50%;

      text-align: right;
    }

    .size {
      display: none;
      vertical-align: top;
      width: 130px;

      @media (min-width: $largeish) {
        display: inline-block;
      }

      label {
        display: inline-block;
        vertical-align: top;
        margin-right: 11px;

        font-size: 15px;
        font-weight: 700;
        line-height: 40px;
        text-transform: uppercase;
        color: white;
      }
      .button {
        border-radius: 2px 0 0 2px;

        img {
          width: 5px;
        }
      }

      .button:last-of-type {
        border-radius: 0 2px 2px 0;

        img {
          width: 10px;
        }
      }
    }

    .selects {
      display: inline-block;
    }

    .select {
      display: inline-block;
      vertical-align: top;
      width: 171px;
      margin: 0 5px 5px 0;

      @media (min-width: $smallish) {
        width: 211px;
        margin: 0 0 0 16px;
      }
      @media (min-width: $medium) {
        margin: 0 0 0 16px;
      }

      select {
        width: 100%;
      }
    }
  }
}
</style>
